import { type SubmitFunction } from '@remix-run/react'
import { type BackendActions } from '#types/form/wizard.ts'

interface HandleSubmitFormParams {
	submit: SubmitFunction
	fieldKey: string
	actionRoute: string
	id: string
	CSRFToken: string
	backendAction: BackendActions
	currentFormContext: { [key: string]: string }
	entireGlobalState: any
}

export function handleSubmitRegularForm({
	fieldKey,
	currentFormContext,
	id,
	backendAction,
	actionRoute,
	CSRFToken,
	entireGlobalState,
	submit,
}: HandleSubmitFormParams) {
	const formData = new FormData()

	const newDataToSend = {
		...entireGlobalState.formState,
		...currentFormContext,
	}

	Object.keys(newDataToSend).forEach(key => {
		const value = newDataToSend[key]
		formData.append(
			`${key}`,
			typeof value === 'object' ? JSON.stringify(value) : value,
		)
	})

	formData.append('id', id)
	formData.append('csrf', CSRFToken)
	formData.append('backendAction', backendAction)
	formData.append('fieldKey', fieldKey)

	submit(formData, { method: 'post', action: `${actionRoute}` })
}
